// deps
import React, { memo } from "react";

// internal-deps
import { IColors, ITypographyV2 } from "@swiggy-private/dls-web-common/dist/components/types.internal";
import { isEmpty, useEffectOnce } from "@swiggy-private/core-ui";

// interfaces
import { ISavingWidget } from "@dineout-cart-ui/interfaces";

// components
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

// styles
import { ComponentWrapper, ImageContainer, TitleText } from "./styles";

function replaceEmWithB(html = ""): string {
    /* HACK: This is a hack to replace <em> with <b> in the html string because currently BE is sending <em> tags
     * in the html string and this can not be readily updated on BE until the RN flow is deprecated since RN flow is
     * having an incorrect transformation of <b> tag and it skips the text altogether if it comes in <b> tag */
    //TODO: Remove this once BE is updated to send <b> tags instead of <em> tags post RN deprecation
    return html.replace(/<em>/g, "<b>").replace(/<\/em>/g, "</b>");
}

const SavingWidget = ({ props, onImpression }: { props: ISavingWidget; onImpression: () => void }) => {
    const { widgetInfo } = props;

    useEffectOnce(() => {
        if (!isEmpty(widgetInfo)) onImpression?.();
    });

    if (isEmpty(widgetInfo)) {
        return null;
    }
    const {
        parentStyle,
        savingTextStyle,
        savingsText,
        text,
        borderColor,
        backgroundColor,
        color,
        icon,
        leftIcon,
        alignment,
    } = widgetInfo || {};
    const IMAGE_DIMENSION = "20"; //20 is the default value

    return (
        <ComponentWrapper
            parentStyle={parentStyle}
            backgroundColor={backgroundColor}
            borderColor={borderColor}
            color={color}
            alignment={alignment}
        >
            {!isEmpty(leftIcon) && (
                <ImageContainer>
                    <Image
                        cloudinaryId={leftIcon}
                        alt=""
                        width={`${IMAGE_DIMENSION}px`}
                        height={`${IMAGE_DIMENSION}px`}
                    />
                </ImageContainer>
            )}
            {savingTextStyle ? (
                <TitleText
                    variant={savingTextStyle.variant as keyof ITypographyV2}
                    color={savingTextStyle.color as keyof IColors}
                    dangerouslySetInnerHTML={{ __html: replaceEmWithB(savingsText || text || "") }}
                />
            ) : (
                <Text
                    style={{ color }}
                    variant={"V2.body2.neutral.regular"}
                    dangerouslySetInnerHTML={{ __html: replaceEmWithB(savingsText || text || "") }}
                />
            )}
            {!isEmpty(icon) && (
                <Image cloudinaryId={icon} alt="" width={`${IMAGE_DIMENSION}px`} height={`${IMAGE_DIMENSION}px`} />
            )}
        </ComponentWrapper>
    );
};

export default memo(SavingWidget);
